import _ from 'lodash'
import React, { Component } from 'react'
import { Helmet } from 'react-helmet'
import styled from 'styled-components'
import { connect } from 'react-redux'
import { updateCalculator, clearCalculator } from '../../../actions/calculator'
import { fetchSports } from '../../../actions/sports'
import Banner from '../../Calculator/Banner'
import CourtTypeCard from '../../Calculator/Card/CourtTypeCard'
import Button from '../../UI/Button'
import { Wrapper, Content, Caret } from './Step0'

const ButtonWrapper = styled.div`
  display: flex;
  justify-content: flex-end;
`

class Step1 extends Component {
  constructor (props) {
    super(props)
    this.state = {
      selectedVariant: {} // Set initial selection to the first card
    }
  }

  componentDidMount () {
    const { sports } = this.props
    const { sport } = this.props.match.params
    console.log('--------FETCHING SPORTS-----', sports[0]);
    // If sports is empty (Usually if this step is reached directly)
    if (sports.length === 0) {
      this.props.fetchSports((sports) => {
        // Get the response directly from the callback and use it
        // Find the sport using the token
        const currentSport = _.find(sports, { token: sport })
        const data = {
          name: currentSport.name,
          active: true,
          visited: true
        }
        // Update the calculator with step number and data to update
        this.props.updateCalculator(1, data)
      })
    } else {
      // Reverted changes made by Kevin - useless
      // let sportsWithoutCage = sports;
      // if (sportsWithoutCage && sportsWithoutCage.length > 0 && sportsWithoutCage[0].token === 'calcetto') {
      //   sportsWithoutCage[0].variants.splice(0, 2);
      // }

      // const currentSport = _.find(sportsWithoutCage, { token: sport })

      const currentSport = _.find(sports, { token: sport })
      const data = {
        name: currentSport.name,
        active: true,
        visited: true
      }
      this.props.updateCalculator(1, data)
      // If a variant has already been selected, show the selected variant
      if (this.props.selectedVariant) {
        this.setState({ selectedVariant: currentSport.variants[this.props.selectedVariant - 1] })
      }
      // this.setState({ selectedVariant: currentSport.variants[0] })
    }
  }

  handleCardSelection (variant) {
    const { sport } = this.props.match.params
    if (variant.id) {
      console.log(variant)
      const path = `/noleggia/${sport}/2?variant=${variant.id}`
      this.props.updateCalculator(1, { variantId: variant.id }) // Saving the variant ID
      this.props.updateCalculator(2, { path }) // Update the path of step 2
      this.props.history.push(path)
    }
  }

  handleNext () {
    const { sport } = this.props.match.params
    const { selectedVariant } = this.state
    console.log(selectedVariant)
    if (selectedVariant.id) {
      const path = `/noleggia/${sport}/2?variant=${selectedVariant.id}`
      this.props.updateCalculator(1, { variantId: selectedVariant.id })
      this.props.updateCalculator(2, { path })
      this.props.history.push(path)
    }
  }

  renderHeadTags () { // Different meta based on the sport selected
    const { sport } = this.props.match.params
    if (sport === 'calcetto') {
      return (
        <Helmet>
          <title>Noleggio campo calcetto</title>
          <meta name='Description' content='Description" content="Configura GRATIS il tuo campo da calcetto smontabile in erba sintetica! Vedrai il prezzo in tempo reale!' />
          <meta name='Keywords' content='campo calcetto erba sintetica,calcetto montabile,campi da calcetto temporanei' />
        </Helmet>
      )
    } else if (sport === 'basket') {
      return (
        <Helmet>
          <title>Noleggio campo basket smontabile</title>
          <meta name='Description' content='Basket 3x3 o Basket 5x5: con il nostro CONFIGURATORE puoi creare il campo più adatto per il tuo evento! Preventivo direttamente on-line senza registrazione!' />
          <meta name='Keywords' content='campo basket smontabile,tabellone basket,pavimento basket' />
        </Helmet>
      )
    } else if (sport === 'beach-volley') {
      return (
        <Helmet>
          <title>Noleggio Campo beach volley</title>
          <meta name='Description' content='Con Noleggiocampi.it configuri il noleggio del tuo campo da beach volley direttamente ON-LINE e SENZA REGISTRAZIONE!' />
          <meta name='Keywords' content='campo beach volley,sabbia beach volley prezzo,costo campo beach volley' />
        </Helmet>
      )
    }
  }

  render () {
    const { sports } = this.props
    const { sport } = this.props.match.params
    const { selectedVariant } = this.state
    const currentSport = _.find(sports, { token: sport })
    // If current sport is undefined the return loading
    if (!currentSport) {
      return (
        <div>Loading...</div>
      )
    }
    return (
      <Wrapper>
        {this.renderHeadTags()}
        <Banner
          title={currentSport.name.toUpperCase()}
          subtitle='SCEGLI LA TIPOLOGIA DI CAMPO;CHE PREFERISCI'
        />
        <Content cardCount={currentSport.variants.length}>
          {currentSport.variants.map((variant, index) => (
            <CourtTypeCard
              key={index}
              title={variant.name === 'Gabbia' ? 'Gabbia' : currentSport.name}
              description={variant.type_name}
              footerText1={variant.dimensions}
              image={`${process.env.PUBLIC_URL}/images/${variant.img}`}
              selected={selectedVariant && selectedVariant.id === variant.id}
              onClick={this.handleCardSelection.bind(this, variant)}
            />
          ))}
        </Content>
        <ButtonWrapper>
          <Button onClick={this.handleNext.bind(this)} size='small'>STEP SUCCESSIVO &nbsp;&nbsp; <Caret fill='#fff' /></Button>
        </ButtonWrapper>
      </Wrapper>
    )
  }
}

function mapStateToProps (state) {
  return {
    sports: state.sports.data,
    selectedVariant: state.calculator.steps[0].variantId
  }
}

export default connect(mapStateToProps, { updateCalculator, fetchSports, clearCalculator })(Step1)



// WEBPACK FOOTER //
// ./src/components/Pages/Calculator/Step1.js